(function () {
  // Hosts da monitorare (production + staging)
  const API_HOSTS = ['api.teddydigital.it', 'stage-api.teddydigital.it'];

  // Codici errore di business logic (non sono bug, non devono essere "error")
  const BUSINESS_LOGIC_CODES = [
    221,    // IDM: User not found
    1000,   // IDM: Password not correct
    1002,   // IDM: Wrong password (repeated)
    200,    // BB: CouponNoPromoActive / CouponCodeNotValid
  ];

  const originalFetch = window.fetch;

  function isApiUrl(urlString) {
    try {
      return API_HOSTS.includes(new URL(urlString).hostname);
    } catch { return false; }
  }

  function reportToSentry(message, level, url, method, status, responsePayload, requestPayload) {
    if (typeof Sentry === 'undefined') return;
    var extra = { url: url, method: method, status: status, response: responsePayload };
    if (requestPayload) extra.requestPayload = requestPayload;
    var outcome = level === 'error' ? 'error' : (level === 'info' && message.startsWith('API Success') ? 'success' : 'business_logic');
    Sentry.captureEvent({
      message: message,
      level: level,
      tags: { source: 'api-interceptor', endpoint: new URL(url).pathname, status: status, outcome: outcome },
      extra: extra
    });
  }

  function checkPayloadError(payload, url, method, status, requestPayload) {
    if (payload && typeof payload === 'object' && payload.error) {
      var code = payload.error.code;
      var isBusinessLogic = BUSINESS_LOGIC_CODES.includes(code);
      var level = isBusinessLogic ? 'info' : 'error';
      var prefix = isBusinessLogic ? 'API Business Logic' : 'API Payload Error';
      reportToSentry(
        prefix + ': ' + (payload.error.message || payload.error.code || JSON.stringify(payload.error)) + ' ' + new URL(url).pathname,
        level, url, method, status, payload, requestPayload
      );
      return true; // aveva un errore nel payload
    }
    return false; // nessun errore nel payload
  }

  function reportSuccess(url, method, status, responsePayload) {
    reportToSentry(
      'API Success: ' + new URL(url).pathname,
      'info', url, method, status, responsePayload, null
    );
  }

  function parseRequestBody(body) {
    if (!body) return null;
    if (typeof body === 'string') {
      try { return JSON.parse(body); } catch (_) { return body; }
    }
    return body;
  }

  // Fetch wrapper
  window.fetch = async function (input, init) {
    var url = typeof input === 'string' ? input : input?.url || '';
    if (!isApiUrl(url)) return originalFetch.apply(this, arguments);

    var method = init?.method || 'GET';
    var reqBody = parseRequestBody(init?.body);

    var response;
    try {
      response = await originalFetch.apply(this, arguments);
    } catch (networkError) {
      if (typeof Sentry !== 'undefined') {
        Sentry.captureException(networkError, {
          tags: { source: 'api-interceptor', endpoint: new URL(url).pathname, outcome: 'error' },
          extra: { url: url, method: method, requestPayload: reqBody }
        });
      }
      throw networkError;
    }

    try {
      var clone = response.clone();
      var body = await clone.text();
      var payload;
      try { payload = JSON.parse(body); } catch (_) { payload = body; }

      if (!response.ok) {
        reportToSentry('API Error: ' + response.status + ' ' + new URL(url).pathname, 'error', url, method, response.status, payload, reqBody);
      } else {
        var hadError = checkPayloadError(payload, url, method, response.status, reqBody);
        if (!hadError) {
          reportSuccess(url, method, response.status, payload);
        }
      }
    } catch (_) {}

    return response;
  };

  // Intercetta anche XMLHttpRequest
  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._sentryMethod = method;
    this._sentryUrl = typeof url === 'string' ? url : String(url);
    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    if (this._sentryUrl && isApiUrl(this._sentryUrl)) {
      this._sentryReqBody = parseRequestBody(body);
      this.addEventListener('loadend', function () {
        try {
          var payload;
          try { payload = JSON.parse(this.responseText); } catch (_) { payload = this.responseText; }

          if (this.status >= 400 || this.status === 0) {
            reportToSentry('API Error: ' + this.status + ' ' + new URL(this._sentryUrl).pathname, 'error', this._sentryUrl, this._sentryMethod, this.status, payload, this._sentryReqBody);
          } else {
            var hadError = checkPayloadError(payload, this._sentryUrl, this._sentryMethod, this.status, this._sentryReqBody);
            if (!hadError) {
              reportSuccess(this._sentryUrl, this._sentryMethod, this.status, payload);
            }
          }
        } catch (_) {}
      });
    }
    return originalSend.apply(this, arguments);
  };
})();
